var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ol', {
    staticClass: "stepper",
    class: {
      'stepper_vertical': _vm.vertical
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "step",
      class: {
        'step_active': item.id === _vm.value,
        'step_disabled': _vm.isDisabledItem(item, index),
        'step_filled': item.filled,
        'step_vertical': _vm.vertical
      }
    }, [_c('div', {
      staticClass: "step__content",
      attrs: {
        "tabindex": _vm.isDisabledItem(item, index) ? -1 : 0,
        "role": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('input', item.id);
        },
        "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.$emit('input', item.id);
        }
      }
    }, [_c('div', {
      staticClass: "step__number"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _c('div', {
      staticClass: "step__text"
    }, [_vm._v(" " + _vm._s(item.text) + " ")])])]);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }